﻿//import kendo from '@progress/kendo-ui';
import { _address } from './i247.Address.js';

class Mapping {
    constructor () {
        this.green = '#00C800';
        this.blue = '#4472c4';
        this.selectedDepotId = null;
        this.map = null;
        this.infobox = null;
		this.depots = [];
		this.debug = false;
		this.manufacturerId = 0;
		this.serviceId = 0;
		this.level = 1;
		this.tier = 1;
		this.postcode = null;
		this.serviceType = null;
		this.customerId = null;
    }
    
    ResetState () {
        $('#grid').html('');
        $('#map').html('');
        this.selectedDepotId = null;
        this.map = null;
        this.infobox = null;
        this.depots = [];
        this.manufacturerId = 0;
		this.serviceId = 0;		
		this.postcode = null;		
    }

	SetManufacturerId(manufacturerId) {
		this.manufacturerId = manufacturerId;
	}

	SetServiceType(serviceType) {
		this.serviceType = serviceType;
	}

	SetCustomerId(customerId) {
		this.customerId = customerId;
	}    

	GetPostcodeCoordinates() {
		kendo.ui.progress($("body"), true);
        let _this = this;
        if (this.postcode != $('#jobPostcode').val()) {
            this.ResetState();
            this.postcode = $('#jobPostcode').val();
            var coordinatesRequest = _address.GetCoordinates(this.postcode, $('input[name=__RequestVerificationToken]').val(), '');
            $.when(coordinatesRequest).then(function (coordinates) {
                _this.coordinates = coordinates;
                _this.RefreshMap(coordinates);
                var depotsRequest = _this.GetDepotList(coordinates.latitude, coordinates.longitude);
                $.when(depotsRequest).then(function (response) {
                    _this.depots = response;
                    var clusterDepots = false;
                    _this.PlotDepots(clusterDepots);
                    _this.RefreshDepotList();
                    kendo.ui.progress($("body"), false);
                });
            });
        }
        else {
            kendo.ui.progress($("body"), false);
        }
    }

    RefreshMap (coords) {
        let _this = this;
        if (!coords) coords = _this.coordinates;
        // Create map
        var jobLocation = new Microsoft.Maps.Location(coords.latitude, coords.longitude);
        _this.map = new Microsoft.Maps.Map(document.getElementById('map'), {
            center: jobLocation,
            zoom: 12
        });
        // Create an infobox for depot information. This is hidden by default, and
        // populated and displayed when a pushpin is selected
        _this.infobox = new Microsoft.Maps.Infobox(_this.map.getCenter(), {
            visible: false,
            autoAlignment: true
        });
        _this.infobox.setMap(_this.map);

        // Draw proximity circles
        Microsoft.Maps.loadModule('Microsoft.Maps.SpatialMath', function () {
            // Inner circle
            var greenFill = new Microsoft.Maps.Color(0.1, 0, 200, 0);
            var greenStroke = new Microsoft.Maps.Color(1, 0, 200, 0);
            _this.DrawMapCircle(jobLocation, 5, greenFill, greenStroke);

            // Outer circle
            var blueFill = new Microsoft.Maps.Color(0, 0, 0, 200);
            var blueStroke = new Microsoft.Maps.Color(1, 0, 0, 200);
            _this.DrawMapCircle(jobLocation, 10, blueFill, blueStroke);

            // Add a pushpin at the user's location.
            var pin = new Microsoft.Maps.Pushpin(jobLocation);
            _this.map.entities.push(pin);
        });
    }


}

export let _mapping = new Mapping();
